import * as actionTypes from "../ActionTypes";

// ✅ Save CareCell Video
export const saveCarecellVideoRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.SAVE_CARECELL_VIDEO_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const saveCarecellVideoSuccess = (data) => ({
  type: actionTypes.SAVE_CARECELL_VIDEO_SUCCESS,
  payload: data,
});

export const saveCarecellVideoFailure = (error) => ({
  type: actionTypes.SAVE_CARECELL_VIDEO_FAILURE,
  payload: error,
});

// ✅ Update CareCell Video
export const updateCarecellVideoRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.UPDATE_CARECELL_VIDEO_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const updateCarecellVideoSuccess = (data) => ({
  type: actionTypes.UPDATE_CARECELL_VIDEO_SUCCESS,
  payload: data,
});

export const updateCarecellVideoFailure = (error) => ({
  type: actionTypes.UPDATE_CARECELL_VIDEO_FAILURE,
  payload: error,
});

// ✅ Delete CareCell Video
export const deleteCarecellVideoRequest = (payload, callback) => ({
  type: actionTypes.DELETE_CARECELL_VIDEO_REQUEST,
  payload,
  callback,
});

export const deleteCarecellVideoSuccess = (data) => ({
  type: actionTypes.DELETE_CARECELL_VIDEO_SUCCESS,
  payload: data,
});

export const deleteCarecellVideoFailure = (error) => ({
  type: actionTypes.DELETE_CARECELL_VIDEO_FAILURE,
  payload: error,
});

// ✅ Read CareCell Videos
export const readCarecellVideoRequest = (payload, callback) => ({
  type: actionTypes.READ_CARECELL_VIDEO_REQUEST,
  payload,
  callback,
});

export const readCarecellVideoSuccess = (data) => ({
  type: actionTypes.READ_CARECELL_VIDEO_SUCCESS,
  payload: data,
});

export const readCarecellVideoFailure = (error) => ({
  type: actionTypes.READ_CARECELL_VIDEO_FAILURE,
  payload: error,
});
